export const determineScoreError = ({
  averageScore,
  projectionValue
}: {
  averageScore?: number;
  projectionValue: number | '';
}): boolean => {
  return (
    projectionValue !== '' &&
    !!averageScore &&
    Math.abs(projectionValue - averageScore) / projectionValue > 0.25
  );
};
